import converter from "../../../libs/number-to-words";
import common from "../../common";
import QuestionModuleStats from "../../maths/modules/QuestionModuleStats";
import QuestionModel from "../../maths/QuestionModel";
import QuestionValueGraphLabel from "../../maths/QuestionValueGraphLabel";
import QuestionView from "./QuestionView";

export default class QuestionViewGraphTally extends QuestionView {
    constructor(question) {
        super(question);

        this._graph = new PIXI.Container();
        this._graph.position.set(0, 280);
        this.addChild(this._graph);

        this._key = new PIXI.Container();
        this._key.position.set(130, 250);
        this.addChild(this._key);

        this._confirmButton.x = this._footer.x + 400;
        this._generated = [];

        this.createGraph();

        if (question.templateType === QuestionModuleStats.TYPE_SAME) {
            this._inputField.visible = false;
        }
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const name = data.template ? data.template : this._question.module;
        let templates = data["templates"][name][this._question.type];

        if (templates) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        }

        if (!templates || !templates.length) {
            console.error("ERROR: NO TEMPLATE FOUND");
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);
        const words = data["words"];

        let text = this._template ? this._template.text : "";

        this._graphLabelCopies = [];
        let itemLabels = words.tally_labels[this._template.tally_label || 0].slice(); ////P3.utils.selectRandom(words.graph_labels).slice();

        const labelObj = {};

        let answerLabelA = null;
        let answerLabelB = null;
        let answerLabelC = null;

        //draw a random label for each value
        for (let i = 0; i < this._question.values.length; i++) {
            const itemIndex = i < itemLabels.length - 1 ? i : itemLabels.length - 1;
            const itemLabel = itemLabels[itemIndex];
            this._graphLabelCopies.push(itemLabel);

            if (this._question.answerIndex.length) {
                if (i === this._question.answerIndex[0]) {
                    this._question.answer.label = itemLabel;
                } else if (i === this._question.answerIndex[1]) {
                    this._question.answer.label += "," + itemLabel;
                }
            }
            else if (i === this._question.answerIndex) {
                this._question.answer.label = itemLabel;//fill answer label if we are asked to find a label
                if (this._question.templateType === QuestionModuleStats.TYPE_LOW ||
                    this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
                    this._question.templateType === QuestionModuleStats.TYPE_EXACT) {
                    this._question.options.push(new QuestionValueGraphLabel(0, itemLabel));
                }
            }
            else if (i === this._question.labelIndexA) {
                answerLabelA = itemLabel;
            }
            else if (i === this._question.labelIndexB) {
                answerLabelB = itemLabel;
            }
            else if (i === this._question.labelIndexC) {
                answerLabelC = itemLabel;
            }
            else {
                labelObj["[ITEM" + i + "]"] = itemLabel;//build obj for easy swapping using regex
            }
            if ((this._question.templateType === QuestionModuleStats.TYPE_LOW ||
                this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
                this._question.templateType === QuestionModuleStats.TYPE_EXACT)
                && this._question.options.length < 5 && i !== this._question.answerIndex) {
                this._question.options.push(new QuestionValueGraphLabel(-1, itemLabel));
            }

            if (this._question.templateType === QuestionModuleStats.TYPE_SAME && this._question.options.length < this._question.values.length) {
                this._question.options.push(new QuestionValueGraphLabel(-1, itemLabel));
            }
        }

        if (text) {
            const names = this.generateWords(this._template.text, words.names, /\[NAME([0-9])?]/g);
            for (const i in names) {
                if (names.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), names[i]);
                }
            }
            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }
            const friendlies = this.generateWords(this._template.text, words.friendly, /\[FRIENDLY([0-9])?]/g);
            for (const i in friendlies) {
                if (friendlies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), friendlies[i]);
                }
            }
            const items = this.generateWords(this._template.text, words.items, /\[ITEM_([A-Za-z])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    if (i === "[ITEM_A]" && answerLabelA) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelA);
                    }
                    else if (i === "[ITEM_B]" && answerLabelB) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelB);
                    }
                    else if (i === "[ITEM_C]" && answerLabelB) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelC);
                    }
                    else {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), labelObj[i]);
                    }
                }
            }
            const values = this.generateValues(this._template.text, /\[VALUE]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), this._question.answer.value);
                }
            }
        }

        return text;
    }

    createGraph() {
        this.createTally();
    }

    createTally() {
        //graph bg adjusted
        this._graph.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 44, 88, 44, 88);
        this._graph.image.position.set(0, 60);
        this._graph.image.width = 360;
        this._graph.image.height = 310;
        this._graph.image.pivot.set(this._graph.image.width * 0.5, this._graph.image.height * 0.5);
        this._graph.addChild(this._graph.image);

        const spacing = 10;
        const ySpacing = 80;

        let yHeight = 0;

        const tallyWidth = spacing * 4;

        //create tally lines
        for (let i = 0; i < this._question.values.length; i++) {
            const value = this._question.values[i].value;

            const tally = new PIXI.Container();
            this._graph.addChild(tally);

            tally.x = 30;
            tally.y = yHeight - 20;
            tally.markHolder = new PIXI.Container();
            tally.addChild(tally.markHolder);
            tally.markHolder.scale.set(0.8, 0.25);

            for (let j = 0; j < value; j++) {
                const mark = new PIXI.Sprite(P3.assets.texture("tally_0"));
                mark.anchor.set(0, 0.5);
                mark.scale.set(0.5);
                mark.x = j * spacing - 50;
                if (j !== 0 && j % 5 === 4) {
                    //make cross out mark
                    mark.texture = P3.assets.texture("tally_1");
                    mark.x -= tallyWidth;//nudge it to the left
                    mark.width = tallyWidth + 6;
                }
                tally.markHolder.addChild(mark);
            }

            //add label
            const label = new PIXI.Text(this._graphLabelCopies[i].toUpperCase(), {
                fontSize: 12,
                fontFamily: "BBC Reith Sans",
                fontWeight: "bold",
                fill: 0x0
            });

            label.x = -60;
            label.anchor.set(1, 0.5);

            tally.addChild(label);

            yHeight += ySpacing * 0.5;
        }

    }

    generateWords(text, options, regex) {
        const words = {};
        options = options.slice();

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const name = P3.utils.selectRandom(options);
                !words[t] && (words[t] = name);
                options.splice(options.indexOf(name), 1);
            }
        }
        return words;
    }

    generateValues(text, regex) {
        const values = {};

        //TODO - this should be set in the question rather than using type
        const useWords = this._question.type === QuestionModel.TYPE_MULTIPLICATION ?
            Math.random() < 0.5 : false;

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const match = t.match(/[0-9]/);
                const index = match ? parseInt(match[0]) : 0;
                console.log(match);
                const value = this._question.values[index].value;
                if (!values[t]) {
                    values[t] = useWords ? converter.toWords(value) : value;
                }
            }
        }
        return values;
    }

    destroy() {
        if (this._generated) {
            for (let i = 0; i < this._generated.length; i++) {
                this._generated[i].destroy(true);
            }
        }
        super.destroy();
    }

    filterTemplate(x) {
        return x.type === this._question.templateType;
    }

    isCorrect() {
        if (this._question.templateType === QuestionModuleStats.TYPE_SAME) {
            const answerArr = this._question.answer.toString().split(",");
            const answerReverse = answerArr[1] + "," + answerArr[0];
            return this._inputValue.toString() === this._question.answer.toString() || this._inputValue.toString() === answerReverse;
        }
        else if (this._question.templateType === QuestionModuleStats.TYPE_LOW ||
            this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
            this._question.templateType === QuestionModuleStats.TYPE_EXACT) {
            return this._inputValue.toString() === this._question.answer.toString();
        }
        return parseInt(this._inputValue.value) === parseInt(this._question.answer.value);
    }

    get graph() {
        return this._graph;
    }
}